import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import RealTalkSection from './components/RealTalkSection';
import TheShiftSection from './components/TheShiftSection';
import SocialProofSection from './components/SocialProofSection';
import TestimonialSection from './components/TestimonialSection';
import InvitationSection from './components/InvitationSection';
import CTASection from './components/CTASection';
import ClosingSection from './components/ClosingSection';
import FloatingCTA from './components/FloatingCTA';
import Footer from './components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <StorySection />
      <RealTalkSection />
      <TheShiftSection />
      <SocialProofSection />
      <TestimonialSection />
      <InvitationSection />
      <CTASection />
      <ClosingSection />
      <Footer />
      <FloatingCTA />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
